export const STAGING = 'STAGING';
export const PROD = 'PROD';
export const LOCAL = 'LOCAL';